import { createSlice } from '@reduxjs/toolkit';
import { TOGGLE_FIELDS } from '../../constants/workflow-builder-config';

const initialState = {
  loading: true,
  contentLoading: false,
  ...TOGGLE_FIELDS.reduce((acc, { key }) => ({ ...acc, [key]: false }), {}),
};

const workflowBuilderConfigSlice = createSlice({
  name: 'workflowBuilderConfig',
  initialState,
  reducers: {
    fetchWorkflowBuilderConfigSuccess: (state, { payload }) => {
      TOGGLE_FIELDS.forEach(({ key }) => {
        state[key] = payload?.[key] ?? false;
      });
      state.loading = false;
    },
    fetchWorkflowBuilderConfigFailure: (state) => {
      state.loading = false;
    },
    updateConfig: (state) => {
      state.contentLoading = true;
    },
    updateConfigSuccess: (state, { payload }) => {
      TOGGLE_FIELDS.forEach(({ key }) => {
        if (payload && key in payload) {
          state[key] = payload[key];
        }
      });
      state.contentLoading = false;
    },
    updateConfigFailure: (state) => {
      state.contentLoading = false;
    },
  },
});

export const {
  fetchWorkflowBuilderConfigSuccess,
  fetchWorkflowBuilderConfigFailure,
  updateConfig,
  updateConfigSuccess,
  updateConfigFailure,
} = workflowBuilderConfigSlice.actions;

export default workflowBuilderConfigSlice.reducer;
